<div class="pms-modal-header">
    <div class="d-flex align-items-center gap-3">
        <div class="pms-icon">
            <i class="bi bi-buildings"></i>
        </div>
        <div>
            <h5 class="modal-title mb-1">PMS Credential Authentication</h5>
            <p class="mb-0 pms-subtitle">Kindly provide your property management information below</p>
        </div>
    </div>
</div>
<div class="modal-body" [formGroup]="pmsForm">
    <div class="mb-3">
        <label class="req block-lbl" for="pmsProvider">PMS / Channel Manager Type
            <span class="text-danger">*</span></label>
        <select formControlName="provider" class="form-select" id="pmsProvider">
            <option value="" disabled>Select PMS Type</option>
            <option *ngFor="let provider of providers" [value]="provider.provider_key">
                {{ provider.label }}
            </option>
        </select>
        <div *ngIf="pmsForm.get('provider')?.touched && pmsForm.get('provider')?.hasError('required')"
            class="text-danger mt-1" style="font-size: 0.8rem;">
            PMS type is required
        </div>
    </div>
    <div class="row">
        <div class="col-md-6 mb-3">
            <label class="req block-lbl" for="pmsEmail">Email <span class="text-danger">*</span></label>
            <input type="email" formControlName="email" class="form-control" id="pmsEmail"
                placeholder="Enter email">
            <div *ngIf="pmsForm.get('email')?.touched && pmsForm.get('email')?.hasError('required')"
                class="text-danger mt-1" style="font-size: 0.8rem;">
                Email is required
            </div>
            <div *ngIf="pmsForm.get('email')?.touched && pmsForm.get('email')?.hasError('email')"
                class="text-danger mt-1" style="font-size: 0.8rem;">
                Please enter a valid email
            </div>
        </div>
        <div class="col-md-6 mb-3">
            <label class="req block-lbl" for="pmsPassword">Password <span class="text-danger">*</span></label>
            <div class="input-group">
                <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                    class="form-control" id="pmsPassword" placeholder="Enter Password">
                <span class="input-group-text pms-password-toggle" (click)="togglePasswordVisibility()">
                    <i [ngClass]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </span>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer pms-modal-footer">
    <button class="btn btn-outline-secondary pms-cancel-btn" (click)="onCancel()" [disabled]="isAuthenticating">Cancel</button>
    <button class="btn btn-primary pms-auth-btn" (click)="onAuthenticate()" [disabled]="isAuthenticating">
        <span *ngIf="isAuthenticating" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
        {{ isAuthenticating ? 'Authenticating...' : 'Authenticate' }}
    </button>
</div>
